<template>
<div class="followup" :class="{'active':FRSubmitList.length > 0}">
  <div class="followup--header">
    <div class="followup--header--title">
      <div class="title--back iconfont" @click="$router.push('/')">&#xe600;</div>
      <div class="title--desc">营销日志</div>
      <div class="title--add iconfont" @click="$router.push('/addfollowup')">&#xe602;</div>
<!--      <div class="title&#45;&#45;add iconfont"></div>-->
    </div>
    <div class="followup--header--filter" v-if="false">
      <div class="filter--time">
        全部时间<span class="iconfont">&#xe603;</span>
      </div>
      <div class="filter--type filter--time">
        全部类型<span class="iconfont">&#xe603;</span>
      </div>
    </div>
    <div class="followup--header--desc" v-if="FRdraftList.length>0 && false">
      <van-swipe class="my-swipe" indicator-color="#7186d3">
        <van-swipe-item v-for="item in FRdraftList" :key="item.id">
          <div class="header--desc--card"  @click="handleToEditorFollowRecord(item)">
            <div class="desc--text">
              <div class="desc--address">{{item.visitDate}} {{item.address}}</div>
              <div class="desc--status">已保存为草稿，请完善后提交。</div>
            </div>
            <div class="desc--icon iconfont">&#xe62c;</div>
          </div>
        </van-swipe-item>
      </van-swipe>
    </div>
<!--    <div class="viewmarket&#45;&#45;header&#45;&#45;empty" v-else>-->
<!--      暂无跟进记录保存条目-->
<!--    </div>-->
  </div>
  <div class="followup--line" :class="{active: true || FRdraftList.length===0}"></div>
  <div class="followup--info" v-if="FRSubmitList.length>0">
    <div
      class="followup--info--item"
      v-for="content in FRSubmitList"
      :key="content.id"
      @click="handleToEditorFollowRecord(content)"
    >
      <div class="item--title">
        <div class="title--desc">{{content.cusName}}</div>
        <div class="title--status">{{ handleToFollowupTypeText(content.followType)}}</div>
      </div>
      <div class="item--addr">
        <div class="title--time">{{content.visitDate | getMonDay}}</div>
        <div class="title--addr" v-if="content.followType === '1'">{{content.address?content.address:'未定位'}}</div>
      </div>
      <div class="item--desc">{{content.remark}}</div>
      <div
        class="item--swiper"
        v-if="content.docEReceiveList.length > 0"
      >
        <swiper class="echw-fb-swiper" :options="swiperOption">
          <swiper-slide
            class="echw-fb-swiper-slide"
            v-for="(imgItem,imgIndex) in content.docEReceiveList"
            :key="imgItem.pk"
          >
            <img @click.stop="handleToFollowupDetailImg(content.docEReceiveList,imgIndex)" class="swiper--img" :src="imgItem.downloadUrl" alt="">
          </swiper-slide>
          <div v-if="false" class="swiper-pagination"  slot="pagination"></div>
        </swiper>
      </div>
      <div class="item--follow">
        <div class="item--follow--person">参与人:{{content.actornames}}</div>
      </div>
    </div>
  </div>
  <div class="followup--info" v-else>
    <van-empty description="暂无数据" />
  </div>
  <div class="follow--big--img">
    <div class="md-example-child md-example-child-image-reader">
      <md-image-viewer
        v-model="imgShow"
        :list="imgurlList"
        :has-dots="true"
        :initial-index="imgIndex">
      </md-image-viewer>
    </div>
  </div>
</div>
</template>

<script type="text/ecmascript-6">
import { get } from '../api/api'
import { ImageViewer } from 'mand-mobile'
import recordPageTime from '../mixin/minin'
// import { getFollowupType } from '../tools/common'
export default {
  name: 'Followup',
  components: {
    [ImageViewer.name]: ImageViewer
  },
  data () {
    return {
      swiperOption: {
        centeredSlides: false, // 当前slide居中显示
        slidesPerView: 3, // 1是显示1个banner, 'auto'自适应
        spaceBetween: 12, // slide间隔（px）
        loop: false,
        autoplay: false,
        delay: 5000, // 自动轮播， 默认 3000 ms
        simulateTouch: true, // 鼠标拖拽
        allowTouchMove: true, // 触摸滑动
        lazyLoading: true,
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets',
          clickable: true
        }
      },
      pageNum: 1, // 获取跟进记录列表从那一条开始
      pageSize: 10, // 获取跟进记录列表一共多少条
      FRdraftList: [], // 保存跟进记录列表
      FRSubmitList: [], // 提交（已添加）跟进记录列表
      FRTypeTextList: [], // 跟进方式字典项
      scrollNum: 50, // 滑动到底部提前控制触发的数值
      scrollRecordFlag: true, // 控制滑动pageNum在没有返回值的时候不能加1
      imgurlList: [], // 控制图片全屏显示
      imgShow: false, // 控制图片全屏显示
      imgIndex: 0 // 控制图片全屏显示
    }
  },
  beforeMount () {
    this.getFollowupRecordList()
  },
  mounted () {
    // const followContentElement = document.body
    window.addEventListener('scroll', this.handleToFollowupListScroll, true)
  },
  destroyed () {
    // const followContentElement = document.body
    window.removeEventListener('scroll', this.handleToFollowupListScroll, true)
  },
  methods: {
    // 获取跟进记录列表
    async getFollowupRecordList () {
      const TypeData = await get('/api/CBMS-APP/sDic/getOpttypeList', {
        opttype: 'STD_MM_FOLLOW_TYPE'
      })
      if (TypeData.success) {
        this.FRTypeTextList = TypeData.data
      }
      const result = await get('/api/CBMS-APP/mmFollowRecord/list', {
        pageNum: this.pageNum,
        pageSize: this.pageSize
      })
      if (result.success) {
        this.FRdraftList = result.data.mmFollowRecordList.filter(item => item.couldEdit === true)
        this.FRSubmitList = this.FRSubmitList.concat(result.data.mmFollowRecordIPage.records)
        this.FRTotal = result.data.mmFollowRecordIPage.total
      } else {
        this.$toast.success('获取数据报错')
      }
    },
    // 滑动到手机底部触发的函数
    async handleToFollowupListScroll (e) {
      // 变量scrollTop是滚动条滚动时，距离顶部的距离
      var scrollTop = e.target.scrollTop
      // 变量windowHeight是可视区的高度
      var windowHeight = e.target.clientHeight
      // 变量scrollHeight是滚动条的总高度
      var scrollHeight = e.target.scrollHeight
      // 滚动条到底部的条件
      if (scrollTop + windowHeight + this.scrollNum >= scrollHeight) {
        if (this.FRSubmitList.length < this.FRTotal && this.scrollRecordFlag) {
          this.pageNum = this.pageNum + 1
          this.scrollRecordFlag = false
          const result = await get('/api/CBMS-APP/mmFollowRecord/list', {
            pageNum: this.pageNum,
            pageSize: this.pageSize
          })
          if (result.success) {
            this.scrollRecordFlag = true
            this.FRSubmitList = this.FRSubmitList.concat(result.data.mmFollowRecordIPage.records)
          } else {
            this.$toast.success('获取数据报错')
          }
        } else if (this.FRSubmitList.length === this.FRTotal) {
          this.scrollNum = 0
          this.$toast.success('数据已全部加载')
        }
      }
    },
    // 获取跟进类型文本
    handleToFollowupTypeText (val) {
      const data = this.FRTypeTextList.filter(item => item.enname === val)[0]
      return data ? data.cnname : '无'
    },
    // 修改跟进记录信息
    handleToEditorFollowRecord (item) {
      this.$router.push({ name: 'addfollowup', params: { item, routerName: 'followup', modifyTag: true } })
    },
    // 点击轮播上图片触发的函数
    handleToFollowupDetailImg (imgList, imgIndex) {
      // this.imgurlList = []
      // this.imgIndex = 0
      imgList.forEach(item => {
        this.imgurlList.push(item.downloadUrl)
      })
      this.imgIndex = imgIndex
      this.imgShow = true
    }
  },
  filters: {
    getFollowTypeText (val, list) {
      const data = list.filter(item => item.enname === val)[0]
      return data.cnname
    },
    getMonDay (time) {
      return time.split(' ')[0].split('-').slice(1).join('-')
    }
  },
  watch: {
    imgShow (newVal, oldVal) {
      if (!newVal) {
        this.imgurlList = []
        this.imgIndex = 0
      }
    }
  },
  mixins: [recordPageTime]
  // beforeRouteLeave (to, from, next) {
  //   const tourl = to.path
  //   const fromurl = from.path
  //   post('/api/CBMS-APP/mmMarketMatter/visit', { tourl, fromurl })
  //   next()
  // }
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
.followup
  position : relative
  width : 100vw
  height : 100vh
  overflow-x : hidden
  background-color : #ffffff
  overflow-y : scroll
  &.active
    padding-bottom : 64px
  .followup--header
    position : fixed
    top:0
    left :0
    width : 100%
    z-index : 10
    .followup--header--title
      display : flex
      align-items : center
      background :#687591
      font-family: MyriadPro-Regular
      font-size: 38px
      font-weight: normal
      font-stretch: normal
      color: #ffffff
      .title--back
        font-size: 38px
        width : 100px
        padding : 16px 0 16px 16px
      .title--add
        width : 100px
        font-size: 38px
        padding : 16px 16px 16px 0
        text-align : right
      .title--desc
        flex : 1
        padding : 16px 0
        text-align : center
    .followup--header--filter
      display : flex
      justify-content : center
      align-items : center
      background-color : #ffffff
      border-bottom : 1px solid #f7f7f7
      .filter--time
        flex : 1
        padding : 19px 0
        text-align : center
        font-family: MyriadPro-Regular
        font-size: 32px
        font-weight: normal
        font-stretch: normal
        color: #333333
        border-right : 1px solid #f7f7f7
        span
          padding-left : 16px
      .filter--type
        border-left : 1px solid #f7f7f7
    .followup--header--desc
      padding : 16px
      box-sizing : border-box
      border-bottom : 1px solid #b6b5b5
      background-color : #ffffff
      .header--desc--card
        display : flex
        align-items : center
        .desc--text
          flex : 1
          font-family: MyriadPro-Regular
          font-size: 26px
          font-weight: normal
          font-stretch: normal
          color: #333333
          overflow : hidden
          .desc--address
            width : 100%
            color : #ecbd62
            overflow: hidden
            text-overflow: ellipsis
            white-space: nowrap
          .desc--status
            margin-top : 8px
            font-size : 34px
            color : #ecbd62
        .desc--icon
          width : 80px
          text-align : right
          color : #ecbd62
      &>>>.van-swipe__indicators
        bottom : 0
      &>>>.van-swipe__indicator
        background-color : #a6a1a1
    .viewmarket--header--empty
      padding : 36px 16px
      box-sizing : border-box
      border-bottom : 1px solid #b6b5b5
      background-color : #ffffff
      text-align : center
      font-family: MyriadPro-Regular
      font-size: 28px
      font-weight: normal
      font-stretch: normal
      color: #b6b5b5
  .followup--line
    width : 100%
    height: 186px
    &.active
      height : 78px
  .followup--info
    .followup--info--item
      margin : 16px 16px 0 16px
      padding : 0 16px
      border-radius : 16px
      background-color : #f7f7f7
      .item--addr
        display : flex
        align-items : center
        padding-bottom : 8px
        font-size: 28px
        font-weight: normal
        font-stretch: normal
        color: #7186d3
        .title--time
           width : 120px
        .title--addr
          text-overflow:ellipsis
          overflow:hidden
          white-space:nowrap
      .item--title
        padding-top : 16px
        display : flex
        justify-content : center
        align-items : center
        font-size: 32px
        font-weight: normal
        font-stretch: normal
        color: #333333
        .title--desc
          flex : 1
          padding : 4px 0
          color : #7186d3
        .title--status
          font-size: 28px
          border : 1px solid #a6a1a1
          padding : 4px 8px
          width : 140px
          text-align : center
          border-radius : 12px
      .title--time
        padding : 8px 0
        font-size: 32px
        font-weight: normal
        font-stretch: normal
        color: #7186d3
      .item--desc
        padding : 8px 0
        line-height : 38px
        font-size: 32px
        font-weight: normal
        font-stretch: normal
        color: #333333
      .item--swiper
        padding : 16px
        height : 210px
        .echw-fb-swiper
          width : 100%
          height : 210px
          .echw-fb-swiper-slide
            height : 210px
            img
              width : 100%
              height : 100%
      .item--follow
        display : flex
        justify-content : center
        align-items : center
        font-size: 32px
        font-weight: normal
        font-stretch: normal
        color: #333333
        .item--follow--person
          flex : 1
          padding : 16px 0
          font-size: 28px
          text-align : right
</style>
